import { render, staticRenderFns } from "./DokmanComponentLenkungFreigabe.vue?vue&type=template&id=1ce09d92&scoped=true"
import script from "./DokmanComponentLenkungFreigabe.vue?vue&type=script&lang=js"
export * from "./DokmanComponentLenkungFreigabe.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentLenkungFreigabe.vue?vue&type=style&index=0&id=1ce09d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce09d92",
  null
  
)

export default component.exports